<template>
  <div v-if="visible" class="context">
    <div class="example card text-center mb-3">
      <div class="card-body">
        {{$t('result.context.context-example')}}
        <b>{{result.example}}</b>
        {{$t('result.context.previous-list')}}
      </div>
    </div>
    <div v-if="this.$ncsConfig.result.context.documentHeader" class="document-header card mb-3 p-3">
      <ncs-context-document-header :document="result.document" :text="result.match.text"/>
    </div>
    <ul v-if="result.before.length > 0" class="texts-before list-group">
      <li v-for="text in result.before" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text.text" :elements="text.elements"
                          :moreElementsBefore="result.before.more_elements_before"
                          :moreElementsAfter="result.before.more_elements_after"/>
      </li>
    </ul>
    <ul class="texts-text-match list-group my-3">
      <li class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="result.match.text" :elements="result.match.elements"
                          :matches="result.match.matches" :analysis="true"
                          :moreElementsBefore="result.match.more_elements_before"
                          :moreElementsAfter="result.match.more_elements_after"/>
      </li>
    </ul>
    <ul v-if="result.after.length > 0" class="texts-before list-group">
      <li v-for="text in result.after" class="context-text list-group-item">
        <ncs-context-text :document="result.document" :text="text.text" :elements="text.elements"
                          :moreElementsBefore="result.after.more_elements_before"
                          :moreElementsAfter="result.after.more_elements_after"/>
      </li>
    </ul>
    <div v-if="result.match.text.original" class="card mt-3">
      <div class="card-body text-justify">
        <b>{{$t('result.context.header.text.original')}}:</b><br/>
        {{result.match.text.original}}
      </div>
    </div>
  </div>
</template>
<script>
  import Ncs from 'ncs'

  export default {extends: Ncs.defaultComponents.NcsContextResult}
</script>